import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

// Import Components
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import IntegrationSection from "./components/IntegrationSection";
import TestimonialSection from "./components/TestimonialSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import DemoPage from "./components/DemoPage";

const Home = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <HeroSection />
      <IntegrationSection />
      <TestimonialSection />
      <ContactSection />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/demo" element={<DemoPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;